/* src/app/chat-widgets/approval-card/approval-card.component.css */
.approval-timeline-container {
  width: 100%;
}
.timeline-node-vertical {
  display: flex;
  align-items: center;
  width: 100%;
}
.timeline-marker-vertical {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.timeline-connector-vertical {
  margin-right: 8px;
  width: 4px;
  height: 4rem;
  background-color: var(--surface-300);
}
.timeline-node i {
  position: absolute;
  bottom: -2rem;
  font-size: 1.5rem;
}
.approver-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
  border: 1px solid #eee;
}
/*# sourceMappingURL=approval-card.component-IVACWFZ2.css.map */
